import {AssetDetails} from "@pages/modal/assets/AssetDetails";

export interface productDetails {
    productId: number;
    productName: string;
    brandName: string;
    quantityValue: number;
    quantityType: string;
    productImage: string;
    productDesc: string;
    minOrderQty: number;
    maxOrderQty: number;
    addedBy: string;
    mainProductCategory: number;
    subProductCategory: number;
    modifiedAt:number;
    isRemoved: boolean;
    createdAt: number
    enabled: boolean
    createdBy: number
    assetDetailsList: AssetDetails[];
}


export class productDetailsData {
    productId: number;
    productName: string;
    addedBy: string;
    mainProductCategory: number;
    subProductCategory: number;
    enabled: boolean;
    productDesc: string;
    createdBy: number
    brandName: string;
    quantityValue: number;
    quantityType: string;
}
